// import { Navigate, useLocation } from 'react-router-dom'
// import { useAuthStore } from '@/store/auth'

// interface AuthGuardProps {
//   children: React.ReactNode
// }

// export function AuthGuard({ children }: AuthGuardProps) {
//   const { isAuthenticated, isLoading } = useAuthStore()
//   const location = useLocation()

//   if (isLoading) {
//     return (
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <div>Loading...</div>
//       </div>
//     )
//   }

//   if (!isAuthenticated) {
//     return <Navigate to="/login" state={{ from: location }} replace />
//   }

//   return <>{children}</>
// }

import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  // ✅ Dev-only bypass (no backend yet)
  const bypass = import.meta.env.VITE_AUTH_BYPASS === 'true'
  if (bypass) return <>{children}</>

  const { isAuthenticated, isLoading, token } = useAuthStore()
  const location = useLocation()

  // With a persisted token, render the app while /user/me refreshes so remounts cannot strand AuthGuard
  if (isLoading && !token) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <div>Loading...</div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}